import { render } from "./InstructorFinder.vue?vue&type=template&id=455594a6"
import script from "./InstructorFinder.vue?vue&type=script&lang=js"
export * from "./InstructorFinder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__